/* tslint:disable */
import { Injectable } from '@angular/core';
import { ApplicationCredential } from '../../models/ApplicationCredential';
import { UserCredential } from '../../models/UserCredential';
import { Class } from '../../models/Class';
import { Course } from '../../models/Course';
import { Category } from '../../models/Category';
import { Annal } from '../../models/Annal';
import { Classwork } from '../../models/Classwork';
import { Quiz } from '../../models/Quiz';
import { Chapter } from '../../models/Chapter';
import { Sequence } from '../../models/Sequence';
import { Question } from '../../models/Question';
import { Subscription } from '../../models/Subscription';
import { Forum } from '../../models/Forum';
import { Thread } from '../../models/Thread';
import { Message } from '../../models/Message';
import { UserBase } from '../../models/UserBase';
import { Article } from '../../models/Article';
import { Condition } from '../../models/Condition';
import { Terms } from '../../models/Terms';
import { Politic } from '../../models/Politic';
import { Payment } from '../../models/Payment';
import { Payservice } from '../../models/Payservice';
import { Activation } from '../../models/Activation';
import { Pricing } from '../../models/Pricing';
import { Statistic } from '../../models/Statistic';
import { Score } from '../../models/Score';
import { Device } from '../../models/Device';
import { Media } from '../../models/Media';
import { MailContact } from '../../models/MailContact';

export interface Models { [name: string]: any }

@Injectable()
export class SDKModels {

  private models: Models = {
    ApplicationCredential: ApplicationCredential,
    UserCredential: UserCredential,
    Class: Class,
    Course: Course,
    Category: Category,
    Annal: Annal,
    Classwork: Classwork,
    Quiz: Quiz,
    Chapter: Chapter,
    Sequence: Sequence,
    Question: Question,
    Subscription: Subscription,
    Forum: Forum,
    Thread: Thread,
    Message: Message,
    UserBase: UserBase,
    Article: Article,
    Condition: Condition,
    Terms: Terms,
    Politic: Politic,
    Payment: Payment,
    Payservice: Payservice,
    Activation: Activation,
    Pricing: Pricing,
    Statistic: Statistic,
    Score: Score,
    Device: Device,
    Media: Media,
    MailContact: MailContact,
    
  };

  public get(modelName: string): any {
    return this.models[modelName];
  }

  public getAll(): Models {
    return this.models;
  }

  public getModelNames(): string[] {
    return Object.keys(this.models);
  }
}
